import { jsx as _jsx } from "react/jsx-runtime";
import { useDeviceUISettings } from 'console/shared/contexts/device-ui-settings';
import { useDeviceUISettingsControl } from 'console/shared/contexts/device-ui-settings/control';
import { Fragment, memo, useMemo } from 'react';
import { ReactSortable } from 'react-sortablejs';
export const SmallUISortablePanels = memo(function SmallUISortablePanels(props) {
    const { list, panel_key, children, ...rest } = props;
    const { sorting_mode } = useDeviceUISettings();
    const { onPanelsDragEnd } = useDeviceUISettingsControl();
    const panels = useMemo(() => list.map(({ id, component }) => _jsx(Fragment, { children: component }, id)), [list]);
    return (_jsx(ReactSortable, { list: list, setList: onPanelsDragEnd, animation: 200, disabled: !sorting_mode, delay: 80, handle: ".panel-drag-handle", className: sorting_mode ? 'sortable-fallback' : undefined, scroll: true, scrollSpeed: 20, scrollSensitivity: 150, forceFallback: true, style: {
            display: 'flex',
            flexDirection: 'column',
            rowGap: 8,
        }, ...rest, children: panels }));
});
